"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  data: [],
  separator: null,
  location: {},
  pathMap: {},
  getPaths: function getPaths() {},
  getPathKey: function getPathKey() {},
  updatePathMap: function updatePathMap() {},
  updateVisible: function updateVisible() {},
  onChange: function onChange() {},
  onRouteChange: function onRouteChange() {},
  setContext: function setContext() {}
});

exports.default = _default;